import React from 'react';
import "./instanceDetailsColumnHeader.scss";

const InstanceDetailsColumnHeader = ({text}) => {
    return (<div className="instance-details-column-header">{text}</div>)
};

export default InstanceDetailsColumnHeader;
